var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { db } from 'data/firestoreClient';
import { SocialError } from 'src/core/domain/common';
import Card from 'react-credit-cards';
import { injectStripe, CardElement } from 'react-stripe-elements';
import { formatCreditCardNumber, formatCVC, formatExpirationDate, formatFormData, } from './utils';
import './stripe.css';
import Input from '@material-ui/core/Input';
import 'react-credit-cards/es/styles-compiled.css';
import 'react-credit-cards/lib/styles.scss';
var CardHandler = /** @class */ (function (_super) {
    __extends(CardHandler, _super);
    function CardHandler(props) {
        var _this = _super.call(this, props) || this;
        _this.stripeCustomerInitialized = {};
        _this.sources = {};
        _this.charges = {};
        _this.form = React.createRef();
        _this.handleCallback = function (_a, isValid) {
            var issuer = _a.issuer;
            //  issuer = this.state.issuer
            //  this.setState({issuer})
        };
        _this.listen = function () {
            db.collection('stripe_customers').doc("" + _this.props.uid).onSnapshot(function (snapshot) {
                _this.stripeCustomerInitialized = (snapshot.data() !== null);
            }, function () {
                _this.stripeCustomerInitialized = false;
            });
            db.collection('stripe_customers').doc("" + _this.props.uid).collection('sources').onSnapshot(function (snapshot) {
                var newSources = {};
                snapshot.forEach(function (doc) {
                    var id = doc.id;
                    newSources[id] = doc.data();
                });
                _this.sources = newSources;
            }, function () {
                _this.sources = {};
            });
            db.collection('stripe_customers').doc("" + _this.props.uid).collection('charges').onSnapshot(function (snapshot) {
                var newCharges = {};
                snapshot.forEach(function (doc) {
                    var id = doc.id;
                    newCharges[id] = doc.data();
                });
                _this.charges = newCharges;
            }, function () {
                _this.charges = {};
            });
        };
        _this.createSource = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        }); };
        _this.createToken = function () { return __awaiter(_this, void 0, void 0, function () {
            var token_1, e_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.props.stripe.createToken({
                                name: this.state.name,
                                address_line1: this.state.address
                            })];
                    case 1:
                        token_1 = _a.sent();
                        console.log('toke', token_1);
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                db.collection('stripe_customers').doc(_this.props.uid).collection('tokens').add({ token: token_1.token.id }).then(function () {
                                    resolve(token_1);
                                })
                                    .catch(function (error) {
                                    reject(new SocialError(error.code, error.message));
                                });
                            })];
                    case 2:
                        e_1 = _a.sent();
                        throw e_1;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.handleInputFocus = function (_a) {
            var target = _a.target;
            _this.setState({
                focused: target.name,
            });
        };
        _this.handleInputChange = function (_a) {
            var target = _a.target;
            var _b;
            if (target.name === 'number') {
                target.value = formatCreditCardNumber(target.value);
            }
            else if (target.name === 'expiry') {
                target.value = formatExpirationDate(target.value);
            }
            else if (target.name === 'cvc') {
                target.value = formatCVC(target.value);
            }
            _this.setState((_b = {}, _b[target.name] = target.value, _b));
            console.log(_this.state.issuer);
        };
        _this.handleRemoveCard = function () { return __awaiter(_this, void 0, void 0, function () {
            var whatsthis;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, db.collection('stripe_customers').doc(this.props.uid).collection('sources').get()];
                    case 1:
                        whatsthis = _a.sent();
                        whatsthis.docs.forEach(function (card) { return __awaiter(_this, void 0, void 0, function () {
                            var fingerprint, del;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        fingerprint = card.data().fingerprint;
                                        console.log(fingerprint);
                                        return [4 /*yield*/, db.collection('stripe_customers').doc(this.props.uid).collection('sources').doc(fingerprint).delete()];
                                    case 1:
                                        del = _a.sent();
                                        console.log('ider', del);
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleSubmit = function (e) {
            e.preventDefault();
            console.log('EEEE', e);
            var issuer = _this.state.issuer;
            _this.createSource();
            _this.createToken();
            // const formData = [...e.target.elements]
            //   .filter(d => d.name)
            //   .reduce((acc, d) => {
            //     console.log('formdata', formData)
            //     console.log('ACC', acc)
            //     console.log('DDDD', d)
            //     acc[d.name] = d.value
            //    return acc
            //   }, {})
            // this.setState({ formData })
            // this.form.reset()
        };
        _this.state = {
            number: '',
            name: '',
            expiry: '',
            cvc: '',
            issuer: '',
            focused: '',
            formData: null,
            zip: '',
            address: ''
        };
        return _this;
    }
    CardHandler.prototype.componentDidMount = function () {
        var _this = this;
        console.log('hello');
        db.collection('stripe_customers').doc("" + this.props.uid).collection('sources').onSnapshot(function (snapshot) {
            var newSources = {};
            console.log('snap', snapshot.size);
            snapshot.forEach(function (doc) {
                // console.log('SRC', doc.id)
                var id = doc.id;
                newSources[id] = doc.data();
                console.log('CLI', newSources[id]);
                if (newSources[id]) {
                    var iss = newSources[id].brand;
                    _this.setState({
                        number: "000000000000" + newSources[id].last4,
                        issuer: iss.toLowerCase(),
                        name: newSources[id].name || '',
                        expiry: newSources[id].exp_month + "/" + newSources[id].exp_year
                    });
                }
            });
        });
    };
    CardHandler.prototype.render = function () {
        var _this = this;
        // const { Name, number, expiry, cvc, focused, issuer, formData } = this.state
        var style = {
            base: {
                iconColor: '#black',
                color: 'black',
                backgroundColor: '#d3d3d3',
                fontWeight: 500,
                fontFamily: 'Arial, Helvetica, sans-serif',
                fontSize: '16px',
                fontSmoothing: 'antialiased',
                marginBottom: '20px',
                paddingLeft: '20px',
                border: '2px solid #e1e8ee',
                borderRadius: '6px',
                ':-webkit-autofill': {
                    color: '#fce883',
                },
                '::placeholder': {
                    color: 'rgba(0, 0, 0, 0.47)',
                },
            },
            invalid: {
                iconColor: '#FFC7EE',
                color: '#FFC7EE',
            },
        };
        return (React.createElement("div", { style: { minWidth: '300px', fontFamily: 'Lato', fontSize: '15px' }, key: 'Payment' },
            React.createElement("div", null,
                this.state.number !== '' ?
                    React.createElement("div", { style: { marginTop: '5%' } },
                        React.createElement("div", { style: { padding: '5px', marginBottom: '3%' } }, "Your Card:"),
                        React.createElement(Card, { number: this.state.number, name: this.state.name, expiry: this.state.expiry, cvc: this.state.cvc, focused: this.state.focused, issuer: this.state.issuer, callback: this.handleCallback }),
                        React.createElement("div", { onClick: this.handleRemoveCard, style: { color: 'red', cursor: 'pointer' } }, "Remove Card "))
                    : React.createElement("div", { style: { width: '100%' } },
                        React.createElement("div", { style: { padding: '12px', fontSize: '16px', fontFamily: 'Lato' } }, "Payment Options:"),
                        React.createElement("form", { style: { margin: '0' }, ref: this.form, onSubmit: this.handleSubmit },
                            React.createElement("div", { style: { width: '100%', fontFamily: 'Arial, Helvetica, sans-serif' }, className: 'exampleinput' },
                                React.createElement(Input, { style: {
                                        marginBottom: '20px',
                                        paddingLeft: '20px',
                                        border: '2px solid #e1e8ee',
                                        borderRadius: '6px'
                                    }, type: 'text', name: 'name', className: 'exampleinput', placeholder: 'Name', required: true, onChange: this.handleInputChange, onFocus: this.handleInputFocus }),
                                React.createElement(Input, { style: {
                                        marginBottom: '20px',
                                        paddingLeft: '20px',
                                        border: '2px solid #e1e8ee',
                                        borderRadius: '6px'
                                    }, type: 'text', name: 'address', className: 'exampleinput', placeholder: 'Address', required: true, onChange: this.handleInputChange, onFocus: this.handleInputFocus })),
                            React.createElement("br", null),
                            React.createElement(CardElement, { onChange: function (e) { _this.setState({ zip: e.brand }); }, style: style }),
                            React.createElement("button", { style: { fontSize: '15px' }, className: 'examplebutton' }, "Add Card"))),
                this.state.formData && (React.createElement("div", { className: 'App-highlight' }, formatFormData(this.state.formData).map(function (d, i) { return React.createElement("div", { key: i }, d); }))))));
    };
    return CardHandler;
}(React.Component));
export default injectStripe(CardHandler);



//////////////////
// WEBPACK FOOTER
// ./src/components/stripe/stripe.tsx
// module id = 1457
// module chunks = 0 1 2 3 5